import React, { useEffect } from 'react'
import './RepertoirePage.scss'
import Header from '../components/Header'
import LeftBarDefault from '../components/LeftBarDefault';
import MainBodyTemp from '../components/MainBodyTemp';
import RightBar from '../components/RightBar';
import Footer from '../components/Footer';
import { useSelector } from 'react-redux';
import { useKeycloak } from "@react-keycloak/web";

function RepertoirePage() {
    const { keycloak } = useKeycloak();
    const baseUrl = useSelector(state => state.baseUrl)
    const inputComponent = <input type="checkbox" defaultChecked={false} />
    const passFlag = useSelector(state => state.loginPage.passFlag)
    const leftBarData = {
        searchPanel: ["Utilizzatore", "Area", "Canale", "Produzione", "ID Produzione", "Codice Produzione", "Tipologia Produzione",
            "Madre", "Edizione", "Genere Produzione", "Master", "ID Master", "Codice Master", "ISAN/EIDR"],
        filterPanel: [
            {
                title: "Canale",
                items: ["Canale 1", "Canale 2"]
            },
            {
                title: "Produzione",
                items: ["Produzione 1", "Produzione 2"]
            },
            {
                title: "Genere produzione",
                items: ["Canale 1", "Canale 2"]
            },
            {
                title: "Master",
                items: ["Produzione 1", "Produzione 2", "Escludi cloni", "Escludi film", "Solo film"]
            },
            {
                title: "Stato",
                items: ["Stato 1", "Stato 2", "Stato 3", "Stato 4", "Stato 5"]
            }
        ]
    }
    const mainBodyData = [
        {
            topTab: "REPORT",
            subTab: [
                {
                    title: "Conf Report",
                    popupData: {
                        title: "PERIODICITA",
                        list: [
                            {
                                title: 'ID Periodicita Report',
                                value: '...'
                            },
                            {
                                title: 'Periodicita Report',
                                value: '...'
                            },
                            {
                                title: 'Descrizione Estesa',
                                value: '...'
                            },
                            {
                                title: 'Algoritmo Periodicita',
                                value: '...'
                            },
                            {
                                title: 'Data Creazione',
                                value: '00/00/0000 00:00'
                            },
                            {
                                title: 'Data Validita',
                                value: '00/00/0000 00:00'
                            },
                            {
                                title: 'Data Obsolescenza',
                                value: '00/00/0000   00:00'
                            },
                            {
                                title: 'Note',
                                value: '...'
                            }
                        ]
                    },
                    table: {
                        heading: ["Cliente", "Commessa", "ID Conf Report", "Conf Report", "Conf Report Descrizione", "Data Inizio",
                            "Data Fine", "Distributire", "Canale", "Produzione", "Data Scadenza"],
                        data: [
                            ["0000", "0000", "0000", "0000", "0000", "01/02/0003 15:47", "01/02/0003 15:47", "DISTR 01",
                                "CANALE 01", "PROD 01", "01/02/0003 15:47"],
                            ["0000", "0000", "0000", "0000", "0000", "01/02/0003 15:47", "01/02/0003 15:47", "DISTR 01",
                                "CANALE 01", "PROD 01", "01/02/0003 15:47"],
                            ["0000", "0000", "0000", "0000", "0000", "01/02/0003 15:47", "01/02/0003 15:47", "DISTR 01",
                                "CANALE 01", "PROD 01", "01/02/0003 15:47"]
                        ]
                    }
                },
                {
                    title: "Report",
                    popupData: {
                        title: "DETTAGLIO MASTER",
                        list: [
                            {
                                title: 'Utilizzatore',
                                value: 'Utilizzatore 1'
                            },
                            {
                                title: 'Canale',
                                value: 'Canale 1'
                            },
                            {
                                title: 'Produzione',
                                value: 'Produzione1'
                            },
                            {
                                title: 'ID Produzione',
                                value: '0000'
                            },
                            {
                                title: 'Codice Produzione',
                                value: '0000'
                            },
                            {
                                title: 'Master',
                                value: 'Master 1'
                            },
                            {
                                title: 'ID Master',
                                value: '0000'
                            },
                            {
                                title: 'Codice Master',
                                value: '0000'
                            },
                            {
                                title: 'ID Master Originale',
                                value: '0000'
                            },
                            {
                                title: 'Numero Episodio',
                                value: 'Episodio 1'
                            },
                            {
                                title: 'Genere Produzione',
                                value: 'Genere 1'
                            },
                            {
                                title: 'Storage Multimedia',
                                value: 'Storage 1'
                            },
                            {
                                title: 'ISAN/EIDR',
                                value: 'Isan 1'
                            },
                            {
                                title: 'Produttore',
                                value: 'Produttore 1'
                            },
                            {
                                title: 'Clone',
                                value: inputComponent
                            },
                            {
                                title: 'Tipo Replica',
                                value: 'Replica 1'
                            },
                            {
                                title: 'Stato',
                                value: '0000'
                            },
                            {
                                title: 'Simulcast',
                                value: '0000'
                            },
                            {
                                title: 'Data Inizio',
                                value: '00/00/0000   00:00'
                            },
                            {
                                title: 'Data Fine',
                                value: '00/00/0000   00:00'
                            },
                            {
                                title: 'Data Creazione',
                                value: '00/00/0000   00:00'
                            },
                            {
                                title: 'Data Modifica',
                                value: '00/00/0000   00:00'
                            },
                            {
                                title: 'Data Obsolescenza',
                                value: '00/00/0000   00:00'
                            },
                            {
                                title: 'Note',
                                value: 'Note...'
                            }
                        ]
                    },
                    table: {
                        heading: [inputComponent, "Cliente", "Commessa", "ID Conf Report", "Conf Report", "ID Report", "Report",
                            "Data Inizio", "Data Fine", "Data Scadenza", "Tipo servizio", "Modello Export", "Export Automatico",
                            "Data Export", "Consegua Automatico", "Data Consegna", "Data Accettazione", "Data Riffuto",
                            "Stato Report", "Data Creazione"],
                        data: [
                            [inputComponent, "0000", "0000", "0000", "0000", "0000", "REPORT 01", "01/02/0003 15:47", "01/02/0003 15:47",
                                "01/02/0003 15:47", "DISTR 01", "CANALE 01", inputComponent, "01/02/0003 15:47", inputComponent,
                                "01/02/0003 15:47", "01/02/0003 15:47", "01/02/0003 15:47", "STATO", "01/02/0003 15:47",],
                            [inputComponent, "0000", "0000", "0000", "0000", "0000", "REPORT 01", "01/02/0003 15:47", "01/02/0003 15:47",
                                "01/02/0003 15:47", "DISTR 01", "CANALE 01", inputComponent, "01/02/0003 15:47", inputComponent,
                                "01/02/0003 15:47", "01/02/0003 15:47", "01/02/0003 15:47", "STATO", "01/02/0003 15:47",],
                            [inputComponent, "0000", "0000", "0000", "0000", "0000", "REPORT 01", "01/02/0003 15:47", "01/02/0003 15:47",
                                "01/02/0003 15:47", "DISTR 01", "CANALE 01", inputComponent, "01/02/0003 15:47", inputComponent,
                                "01/02/0003 15:47", "01/02/0003 15:47", "01/02/0003 15:47", "STATO", "01/02/0003 15:47",],
                        ]
                    }
                }
            ]
        }
    ]
    useEffect(() => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer "+keycloak.token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch(baseUrl + "/v1/repente", requestOptions)
            .then(response => response.text())
            .then(result => {
                // console.log(JSON.parse(result))
            })
            .catch(error => console.log('error', error));

    }, [baseUrl, keycloak])
    return (
        <div className={passFlag ? 'RepertoirePage' : 'hidden'}>
            <Header />
            <div className='middle'>
                <LeftBarDefault leftBarData={leftBarData} />
                <MainBodyTemp mainBodyData={mainBodyData} />
                <RightBar />
            </div>
            <Footer />
        </div>
    )
}

export default RepertoirePage